<div style="display: flex; flex-flow: row wrap; justify-content: center">
  <div style="padding: 1%" *ngFor="let musicalPubEl of filteredMusicalPubs">
    <app-musical-pub-item [musicalPubElement]="musicalPubEl">
    </app-musical-pub-item>
  </div>
</div>
